import React from 'react';

import { useSankeyRenderContext } from 'contexts/sankeyRenderContext';
import Alert from 'ui/Alert';
import List from 'ui/List';

const CircularFlowsDetectedBanner: React.FC = () => {
  const { cycles } = useSankeyRenderContext();

  if (cycles.length > 0) {
    return (
      <Alert
        status="warning"
        title="Circular diagrams are not yet fully supported - some flows have been faded"
      >
        <List.Root>
          {cycles.map(({ humanizedPath, backFlow: { source, target } }) => (
            <List.Item key={humanizedPath} fontSize="xs">
              Flow{' '}
              <i>
                {source} &gt; {target}
              </i>{' '}
              from cycle{' '}
              <b>
                <i>{humanizedPath}</i>
              </b>
            </List.Item>
          ))}
        </List.Root>
      </Alert>
    );
  }

  return null;
};

export default CircularFlowsDetectedBanner;
